import {insert, indexOf} from 'utils/sortedArray'
import isEmpty from 'lodash.isempty'
// import {LEVELS} from 'components/TradeView/OrderBook'
import Big from 'big.js'

const LEVELS = 6

const initialState = {
  askTree: [], // without root
  askLeaves: {},
  bidTree: [], // without root
  bidLeaves: {}
}

function chainAdd (arr, {price, fixedPrice, amount}, level) {
  let node
  const foundIdx = indexOf(arr, fixedPrice, (a, b) => Number(a.price) - b)
  if (foundIdx > -1) {
    // found
    node = arr[foundIdx]
    node.amount += amount
    node.total += Number(price) * amount
  } else {
    // create node
    node = {
      price: fixedPrice,
      amount,
      total: price * amount,
      level
    }
    insert(arr, node, (a, b) => Number(a.price) - Number(b.price))
  }
  return node
}

function chainUpdate (arr, {price, fixedPrice, amountDiff}) {
  let node
  const foundIdx = indexOf(arr, fixedPrice, (a, b) => Number(a.price) - b)
  if (foundIdx > -1) {
    // found
    node = arr[foundIdx]
    node.amount += amountDiff
    if (node.amount === 0) {
      arr.splice(foundIdx, 1)
    }
    node.total += Number(price) * amountDiff
  }
  return node
}

function chainDelete (arr, {price, fixedPrice, amount}) {
  let node
  const foundIdx = indexOf(arr, fixedPrice, (a, b) => a.price - b)
  if (foundIdx > -1) {
    // found
    node = arr[foundIdx]
    node.amount -= amount
    const am = node.amount.toFixed(3)
    if (am === '0.000' || am === '-0.000') {
      arr.splice(foundIdx, 1)
      return null
    }
    node.total -= Number(price) * amount
  }
  return node
}

export function _toFixed (price, tickSize, type) {
  const numPrice = Number(price)
  const iSize = -Big(tickSize).e
  if (tickSize < 1) return numPrice.toFixed(iSize)

  const rest = numPrice % tickSize
  const numPrice1 = (rest < tickSize / 2 ? numPrice - rest : numPrice + tickSize - rest).toFixed(0)
  switch (type) {
  case 'round':
    return numPrice1
  case 'floor':
    return (numPrice - rest).toFixed(0)
  case 'ceil':
    return (numPrice - rest + tickSize).toFixed(0)
  default:
    return numPrice1
  }
}

export function getTsArray () {
  // todo
  const arr = []
  let i = 2  //  BTC 2 decimal
  let flag = true
  while (arr.length < LEVELS) {
    const t = Math.pow(10, -i)
    if (t === 100 && flag) {
      arr.push(50)
      flag = false
    } else {
      arr.push(t)
      i--
    }
  }
  return arr.reverse()
}

function treeAddPrice (tickSize, root, {price, amount}, type) {
  let node = {children: root}
  let i = 0
  const tsArray = getTsArray(tickSize)
  while (node && i < LEVELS) {
    const iSize = tsArray[i]
    const fixedPrice = _toFixed(price, iSize, type)
    node.children = node.children || []
    node = chainAdd(node.children, {price, fixedPrice, amount}, i)
    i++
  }
}

function treeUpdatePrice (tickSize, root, {price, amountDiff}, type) {
  let node = {children: root}
  let i = 0
  const tsArray = getTsArray(tickSize)
  while (node && i < LEVELS) {
    const iSize = tsArray[i]
    const fixedPrice = _toFixed(price, iSize, type)
    node = chainUpdate(node.children, {price, fixedPrice, amountDiff})
    i++
  }
}

function treeDeletePrice (tickSize, root, {price, amount}, type) {
  let node = {children: root}
  let i = 0
  const tsArray = getTsArray(tickSize)
  while (node && i < LEVELS) {
    const iSize = tsArray[i]
    const fixedPrice = _toFixed(price, iSize, type)
    node = chainDelete(node.children, {price, fixedPrice, amount})
    i++
  }
}

const merger = (tickSize, ordersTree, leaves, entities, isFull = false, type) => {
  const newRev = entities[Object.keys(entities)[0]].rev
  if (isFull) {
    Object.keys(leaves).forEach(price => {
      const newObj = entities[price]
      const oldRev = leaves[price]?.rev
      if (!newObj && newRev > oldRev) {
        const amountToDel = leaves[price].amount || 0
        delete leaves[price]
        treeDeletePrice(tickSize, ordersTree, {price, amount: amountToDel}, type)
      }
    })
  }

  Object.keys(entities).forEach(price => {
    const newObj = entities[price]
    const newAmount = Number(newObj.amount)
    const oldRev = leaves[price]?.rev

    if (Number(newAmount) === 0) {
      // delete
      const amountToDelete = leaves[price]?.amount || 0
      delete leaves[price]
      treeDeletePrice(tickSize, ordersTree, {price, amount: amountToDelete}, type)
    } else if (!oldRev) {
      // add new
      leaves[price] = {rev: newRev, amount: newAmount}
      treeAddPrice(tickSize, ordersTree, {price, amount: newAmount}, type)
    } else if (newRev > oldRev) {
      // update
      const amountDiff = newAmount - Number(leaves[price].amount)
      leaves[price] = {rev: newRev, amount: newAmount}
      treeUpdatePrice(tickSize, ordersTree, {price, amountDiff}, type)
    }
  })
}

const getNode = (tree, type) => {
  if (type === 'bid') {
    const last = tree?.length - 1
    const lastChildren = tree?.[last]?.children
    return lastChildren ? getNode(lastChildren, 'bid') : +tree?.[last]?.price
  }
  return tree?.[0]?.children ? getNode(tree?.[0]?.children) : +tree?.[0]?.price
}

export function updateOrders (symbol, state, response, isFull) {
  if (!isEmpty(response?.asks) || !isEmpty(response?.bids)) {
    // TODO: deal with zero data which is not existed in response
    const firstPrice = Object.keys(isEmpty(response?.asks) ? response?.bids : response?.asks)?.[0]
    const tickSize = firstPrice?.split('.')?.[1]?.length || 0

    state[symbol] = state[symbol] || initialState
    const {
      askTree, askLeaves, bidTree, bidLeaves
    } = state[symbol]

    const cross = getNode(askTree) <= getNode(bidTree, 'bid') // check if price cross
    const full = cross || isFull
    if (response?.asks && Object.keys(response.asks).length > 0) {
      merger(tickSize, askTree, askLeaves, response.asks, full, 'ceil')
    }
    if (response?.bids && Object.keys(response.bids).length > 0) {
      merger(tickSize, bidTree, bidLeaves, response.bids, full, 'floor')
    }
  }
}
